<template>
  <FilterButton title="View Options" icon="mdi-format-columns" @close="save" data-test="account-benchmark-view-options"
                data-test-activator="account-benchmark-view-options-activator">
    <template #menu="{ close }">
      <div class="menu">
        <h4>View Options</h4>
        <div class="fields">
          <div class="field">
            <h5>Client Names</h5>
            <label>
              <input type="radio" v-model="selectedLabels" value="showAll" data-test="account-benchmark-view-options-labels-show-all"/>
              <span>Show All</span>
            </label>
            <label>
              <input type="radio" v-model="selectedLabels" value="showNone" data-test="account-benchmark-view-options-labels-show-none"/>
              <span>Show None</span>
            </label>
          </div>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="flat" color="primary" @click="close" data-test="account-benchmark-view-options-apply">Done</v-btn>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script>
import FilterButton from '@/components/FilterButton';

export default {
  name: 'AccountBenchmarkViewOptions',
  components: { FilterButton },
  props: {
    labels: String,
  },
  data() {
    return {
      dirty: false,
      localSelectedLabels: undefined,
    };
  },
  computed: {
    selectedLabels: {
      get() {
        return this.localSelectedLabels || this.labels || 'showAll';
      },
      set(newValue) {
        this.localSelectedLabels = newValue;
      }
    },
  },
  methods: {
    save() {
      if (this.dirty) {
        this.dirty = false;
        this.$emit('change', this.selectedLabels);
      }
      return true;
    }
  },
  watch: {
    selectedLabels() {
      this.dirty = true;
    },
  }
};
</script>

<style scoped>
.menu {
  padding: 1rem 0 0 0;
  min-width: 300px;
}

.menu > h4 {
  padding: 0 1rem;
}

.menu > .fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  padding: 0 1rem 1rem;
}

.menu > .fields > .field > h5 {
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  margin: 1rem 0 0.5rem;
  text-transform: uppercase;
  font-weight: 500;
}

.menu > .fields > .field > label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-items: center;
  align-content: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu > .buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: flex-end;
}
</style>
